<template>
  <role-form-modal
    :header-title="$t('ROLES.ADD.TITLE')"
    :header-content="$t('ROLES.MODAL_DESC')"
    :initial-role-name="''"
    :initial-permissions="initialPermissions"
    :initial-inbox-permissions="initialInboxPermissions"
    :on-close="onClose"
  >
    <template #footer="{ roleName, permissions, inboxPermissions, isValid }">
      <woot-button
        class="cancel-filter-btn button clear text-base px-5 py-3 leading-[20px] h-[48px] font-[400]"
        color-scheme="secondary"
        @click.prevent="onClose"
      >
        {{ $t('ROLES.ADD.CANCEL') }}
      </woot-button>
      <woot-submit-button
        :disabled="!isValid || uiFlags.isCreating"
        :button-text="$t('ROLES.ADD.SUBMIT')"
        :loading="uiFlags.isCreating"
        class="button-filled text-base px-5 py-3 font-[400] h-[48px]"
        @click.native.prevent="addRole(roleName, permissions, inboxPermissions)"
      />
    </template>
  </role-form-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { INBOX_PERMISSIONS, GENERAL_PERMISSIONS } from './constants';
import RoleFormModal from './RoleFormModal.vue';

export default {
  components: { RoleFormModal },
  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      initialPermissions: GENERAL_PERMISSIONS,
      initialInboxPermissions: [],
    };
  },
  computed: {
    ...mapGetters({
      inboxes: 'inboxes/getInboxes',
      uiFlags: 'roles/getUIFlags',
    }),
  },
  async created() {
    this.initialInboxPermissions = this.buildInitialInboxPermissions();
  },
  methods: {
    buildInitialInboxPermissions() {
      const ids = Object.fromEntries(
        this.inboxes.map(inbox => [inbox.id, false])
      );
      return INBOX_PERMISSIONS.map(permission => ({
        name: permission,
        ids: { ...ids },
        default: false,
      }));
    },
    showAlert(message) {
      bus.$emit('newToastMessage', message);
    },
    async addRole(roleName, permissions, inboxPermissions) {
      try {
        await this.$store.dispatch('roles/create', {
          name: roleName,
          permissions,
          inbox_permissions: inboxPermissions,
        });
        this.showAlert(this.$t('ROLES.ADD.API.SUCCESS_MESSAGE'));
        this.onClose();
      } catch (error) {
        this.showAlert(error.message);
      }
    },
  },
};
</script>
